module.exports = __webpack_public_path__ + "img/icon-startups-gray.eb5d2e0d.svg";